import { AuthService } from '@appService/auth.service'
import { ChangeDetectorRef, Component, OnInit } from '@angular/core'
import { environment } from '@appEnv/environment'
//======AUTO IMPORT HERE==========
import { Router } from '@angular/router'
import { KeycloakService } from 'keycloak-angular'
import { PermissionService, VirtualDataSource, VssAuthService, } from 'projects/vss-ui/src/public-api'
import { MenuModel } from '@app/models/menu.model'
import { TranslateService } from '@ngx-translate/core'
import { MenuService } from '@app/service/admin/menu.service'
import { SidebarService } from '@app/service/shares/sidebar-service'

@Component({
  selector: 'vna-layout-full',
  templateUrl: './layout-full.component.html',
  styleUrls: ['./layout-full.component.scss']
})
export class LayoutFullComponent implements OnInit {
  user: any
  totalNewNotify = 0
  sysNotification: any[] = [{ value: 'SMOS', label: 'SMOS', totalNewNotify: 0, total: 0, read: 0 }]
  indexTabNotifyActive = 0
  isHorizontal = environment.config.isHorizontalMenu
  isCollapsed = true
  currentLang: string = localStorage.getItem('language') || 'vi'
  labelTranslate: string = ''
  dataNotify!: VirtualDataSource
  sysNotificationActive = environment.applicationCode
  currentUser: any

  get indexSysNotifyActivate() {
    return this.sysNotification?.findIndex(s => this.sysNotificationActive == s.value)
  }

  public async getLabelTranslate(key: string | string[], params?: object) {
    let output = ''
    await this.translate.get(key, params).toPromise().then(x => output = x)
    return output
  }

  public getLabelTranslateV2(key: string | string[], params?: object): string {
    let output = ''
    this.translate.get(key, params).subscribe(r => {
      output = r
    })
    return output
  }

  onSelectLange(lang: string): void {
    localStorage.setItem('language', lang)
    this.currentLang = lang
    this.translate.use(lang).subscribe(() => {
      this.setMenu(this.menus)
    }
    )

  }

  menus: MenuModel[] = []

  // adminMenus: MenuModel[] = [
  //   {
  //     'icon': 'icons:org-icon',
  //     'iconActive': 'icons:org-icon',
  //     'id': '1',
  //     'level': 0,
  //     'title': 'MENU.ADMIN.ORGANIZATION',
  //     'titleKey': 'MENU.ADMIN.ORGANIZATION',
  //     'url': '/codev/admin/organization-management',
  //     roles: [],
  //     'children': [
  //     ]
  //   },
  //   {
  //     'icon': 'icons:user-icon',
  //     'iconActive': 'icons:user-icon',
  //     'id': '2',
  //     'level': 0,
  //     'title': 'MENU.ADMIN.USER_LIST',
  //     'titleKey': 'MENU.ADMIN.USER_LIST',
  //     'url': '/codev/admin/user-management',
  //     roles: [],
  //     'children': [
  //     ]
  //   },
  // ]


  userMenus: MenuModel[] = []
  language: string = 'en'

  constructor(
    private vssAuthService: VssAuthService,
    private authService: AuthService,
    private cdr: ChangeDetectorRef,
    private router: Router,
    public translate: TranslateService,
    protected readonly keycloakService: KeycloakService,
    private menuService: MenuService,
    private permission: PermissionService,
    private sidebarService: SidebarService,
  ) {
    this.userMenus = this.permission.menuObs.getValue()
    translate.setDefaultLang(this.currentLang)
    translate.use(this.currentLang)

  }


  changeExpand() {
    this.isCollapsed = !this.isCollapsed
  }

  public setMenu(menus: MenuModel[]): void {
    menus.forEach((item, index) => {
      //item.id = `${index}`
      this.translate.get(item.titleKey).subscribe(
        r => {
          item.title = r
        }
      )
      if (item.children.length > 0) {
        this.setMenu(item.children)
      }
    })
  }

  ngOnInit(): void {
    this.cdr?.detectChanges()
    // this.menus = this.authService.isAdministrator() ? this.adminMenus : this.userMenus;
    this.menus = this.userMenus
    this.setMenu(this.menus)

    this.menuService.menuObs.next(this.menus)
    this.sidebarService.toggleSidebar()
  }

  logout() {
    // localStorage.clear()
    this.vssAuthService.logout()
    localStorage.removeItem('logged')
  }

  getModuleName() {
    let url: any = this.router.url
    if (url.includes('/dashboard')) {
      return this.translate.instant('MENU.DASHBOARD')
    }
  }
}
